import { flow, map, uniq, filter, includes, flatten } from "lodash/fp";

export const formatHandler = ({ name, collection }) => {
  return collection.toLowerCase() + "-" + name.toLowerCase();
};

export const getKeys = (values) => {
  if (!values) {
    return [];
  }

  return Object.keys(values);
};

export const getCollectionsHandle = (handle) => {
  if (!handle) {
    return "";
  }
  return handle.split("-")[0];
};
export const getProductHandle = (handle) => {
  if (!handle) {
    return "";
  }
  return `${getCollectionsHandle(handle)}-${getHandleSub(handle)}`;
};

export const getHandleSub = (handle) => {
  if (!handle) {
    return "";
  }
  if (handle.split("-").length < 2) {
    return "";
  }
  return handle.split("-")[1];
};

export const getHandleCapitalize = (handle) => {
  if (!handle) {
    return "";
  }
  if (getCollectionsHandle(handle).length == 0) {
    return "";
  }
  return (
    getCollectionsHandle(handle)[0].toUpperCase() +
    getCollectionsHandle(handle)?.slice(1)
  );
};

export const extractCollectionData = ({ values, level, collection }) => {
  const keys = getKeys(values);

  return {
    keys,
    expanded: false,
    values: keys?.map((i) => ({
      name: i,
      level,
      collection: formatHandler({ values, name: i, collection }),
      expanded: false,
      children: extractCollectionData({
        values: values[i],
        level: level + 1,
        collection: formatHandler({ values, name: i, collection }),
      }),
    })),
  };
};

export const extractCategoryTags = (products) => {
  return flow(
    map("tags"),
    flatten,
    uniq,
    filter((t) => includes("Category:")(t)),
    map((t) => t.replace("Category: ", ""))
  )(products.map((t) => t.node));
};

export const extractCategoryTiers = (products) => {
  const array = extractCategoryTags(products);
  const parse = (elm) => elm.split(" > ");

  const build = (keys, obj, acc) => {
    keys.reduce((a, b) => {
      if (!a[b]) a[b] = {};
      return a[b];
    }, obj);
    Object.assign(acc, obj);
    return acc;
  };

  const obj = {};

  return array
    .map((a) => parse(a))
    .reduce((acc, keys) => build(keys, obj, {}), {});
};
